import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class UniformDto extends BaseAgencyScopeEntityDto {
    state: number;
    name: string;
    description: string;
    image: string;
}